import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  TEAM_ENUM
} from './constants'
import {
  entitiesSelector,
} from 'helpers/ComponentSelectorUtil'

const siteRolesRefs = state => state.admin.siteRoles
const siteRolesChanges = state => state.admin.siteRolesChanges
const siteRolesValues = state => {
  const siteRoles = entitiesSelector(state)['site_role_views']
  return siteRoles ? siteRoles : []
}


const siteRolesSelector = createSelector(
  siteRolesValues,
  siteRolesRefs,
  (values, refs) => refs.map(id => values[id])
)

const filterByRole = R.propEq('role')
const byCpm = filterByRole(TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER)
const byAe = filterByRole(TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER)
const byAem = filterByRole(TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER)
const byFae = filterByRole(TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER)
const byPae = filterByRole(TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER)
const byAm = filterByRole(TEAM_ENUM.ACCOUNT_MANAGER)
const byPm = filterByRole(TEAM_ENUM.PRODUCT_MANAGER)
const byCpd = filterByRole(TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR)
const bySpm = filterByRole(TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER)
const byObs = filterByRole(TEAM_ENUM.OBSERVER)

const cpmSelector = createSelector(
  siteRolesChanges,
  R.filter(byCpm)
)

const aemSelector = createSelector(
  siteRolesChanges,
  R.filter(byAem)
)

const aeSelector = createSelector(
  siteRolesChanges,
  R.filter(byAe)
)

const faeSelector = createSelector(
  siteRolesChanges,
  R.filter(byFae)
)

const amSelector = createSelector(
  siteRolesChanges,
  R.filter(byAm)
)

const cpdSelector = createSelector(
  siteRolesChanges,
  R.filter(byCpd)
)

const spmSelector = createSelector(
  siteRolesChanges,
  R.filter(bySpm)
)

const obsSelector = createSelector(
  siteRolesChanges,
  R.filter(byObs)
)

export {
  aeSelector,
  aemSelector,
  cpmSelector,
  faeSelector,
  amSelector,
  cpdSelector,
  spmSelector,
  obsSelector,
  siteRolesSelector,
  siteRolesChanges,
}


